var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThirdPartyAxisSip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m.641 21 12-18.598 12 18.598zm7.584-8.065 4.416-6.844L20.971 19h-4.863l-3.872-6.065zm-1.29 2L4.312 19h9.423l-2.595-4.065z",
  clipRule: "evenodd"
})));
export { SvgThirdPartyAxisSip as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjY0MTM1NyAyMUwxMi42NDE0IDIuNDAyNEwyNC42NDE0IDIxSDAuNjQxMzU3Wk04LjIyNTM4IDEyLjkzNTFMMTIuNjQxNCA2LjA5MTI0TDIwLjk3MDcgMTlIMTYuMTA3NkwxMi4yMzY0IDEyLjkzNTFIOC4yMjUzOFpNNi45MzQ4OSAxNC45MzUxTDQuMzEyMDUgMTlIMTMuNzM0OUwxMS4xNDAzIDE0LjkzNTFINi45MzQ4OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";